import { useEffect, useState } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import "../payment/payment.css";
import { defaultCard } from "../javascript/function";
import { Link } from "react-router-dom";
import InPlayer from "../backend/inplayer";
import { UserStore } from "../store/store";
import CarouselContentLoader from "../loader/contentLoader";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { getParamByISO } from "iso-country-currency";

let valid = require("card-validator");

const CardModal = (props) => {
  const [cardNumber, setCardNumber] = useState("**** **** **** ****");
  const [cardMonth, setCardMonth] = useState("mm");
  const [cardYear, setCardYear] = useState("yy");
  const [cardType, setCardType] = useState("");
  const [change, setChange] = useState(false);
  const [error, setError] = useState(false);
  const [monthValid, setMonthValid] = useState(true);
  const [cardValid, setCardValid] = useState(true);
  const [owner, setOwner] = useState("Owner Name");
  const [cvvValid, setCvvValid] = useState(true);
  const [nameValid, setnameValid] = useState(true);
  const [cvv, setcvv] = useState("***");
  const [loading, isLoading] = useState(false);
  const currentUser = UserStore.useState((s) => s.user);

  useEffect(() => {
    const getCardDetails = async () => {
      /* eslint-disable no-unused-vars */
      const card = await defaultCard()
        .then((result) => {
          let months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ];

          let country = currentUser.COUNTRY;
          let currency = getParamByISO(country, "currency");
          setCardNumber(result.data.cards[currency].number);
          let index = parseInt(result.data.cards[currency].exp_month) - 1;
          let selectedMonth = months[index];
          setError(false);

          setCardMonth(selectedMonth);
          setCardYear(result.data.cards[currency].exp_year);
        })
        .catch((error) => {
          setError(true);
        });
    };
    getCardDetails();
  }, [currentUser.COUNTRY]);
  const validateCard = () => {
    let numberValidation = valid.number(cardNumber);
    if (numberValidation.isPotentiallyValid && numberValidation.card) {
      setCardType(numberValidation.card.niceType);
      setCardValid(true);
    } else {
      setCardType("");
      setCardValid(false);
    }
  };

  const validateName = () => {
    let validName = valid.cardholderName(owner);

    if (validName.isPotentiallyValid) {
      setnameValid(true);
    } else {
      setnameValid(false);
    }
  };
  const displayCard = (event) => {
    event.preventDefault();
    setChange(!change);
  };
  const validateMonth = () => {
    if (cardMonth && cardYear && cardMonth !== "mm" && cardYear !== "yy") {
      let validMonth = valid.expirationDate(cardMonth + "/" + cardYear);

      if (validMonth.isValid || validMonth.isPotentiallyValid) {
        setMonthValid(true);
      } else {
        setMonthValid(false);
      }
    } else {
      setMonthValid(false);
    }
  };
  const validateCVV = () => {
    let validcvv =
      cardType === "American Express" ? valid.cvv(cvv, 4) : valid.cvv(cvv);

    if (validcvv.isValid) {
      setCvvValid(true);
    } else {
      setCvvValid(false);
    }
  };
  const saveDefaultCard = (event) => {
    event.preventDefault();
    toastr.clear();
    isLoading(true);
    let numberValidation = valid.number(cardNumber);
    let validMonth = valid.expirationDate(cardMonth + "/" + cardYear);
    let validcvv =
      cardType === "American Express" ? valid.cvv(cvv, 4) : valid.cvv(cvv);
    let nameValidation = valid.cardholderName(owner);
    if (validMonth && validcvv && numberValidation) {
      if (
        validMonth.isPotentiallyValid &&
        validcvv.isValid &&
        numberValidation.isPotentiallyValid &&
        nameValidation.isPotentiallyValid
      ) {
        setCardValid(true);
        setMonthValid(true);
        setCvvValid(true);
        setnameValid(true);

        InPlayer.Subscription.setDefaultCreditCard({
          cardNumber: cardNumber,
          cardName: owner,
          cvc: cvv,
          expMonth: cardMonth,
          expYear: cardYear,
          currency: getParamByISO(currentUser.COUNTRY, "currency"),
        })
          .then((data) => {
            toastr.success("Sucessfully Updated Card", "Success");
            isLoading(false);
          })
          .catch((error) => {
            isLoading(false);
            toastr.error("Error in Updating Card", "Error");
          });
      }
    }
  };
  return (
    <Modal
      open={props.open}
      onClose={props.onCloseModal}
      center
      classNames={{
        modal: "customModal",
      }}
    >
      <div className="modal-header">
        <h3 className="modal-title">Card Details</h3>
      </div>
      <div className="modal-body" style={{ minWidth: "320px" }}>
        {error ? (
          <div className="card mb-3">
            <div className="card-header" id="headingTwo">
              <h5 className="mb-0">
                <button
                  className="btn btn-link small-text pl-5 text-left collapsed"
                  aria-expanded="false"
                >
                  {"No Saved Cards to View"}{" "}
                  <span
                    style={{
                      display: "block",
                      fontSize: "11px",
                      color: "var(--iq-text-color)",
                      paddingLeft: "2.6rem",
                    }}
                  >
                    {"Cards are saved only when you purchase subscription"}
                  </span>
                </button>
              </h5>
            </div>
          </div>
        ) : loading ? (
          <CarouselContentLoader></CarouselContentLoader>
        ) : (
          <div className="card mb-3">
            <div className="card-header" id="headingTwo">
              <h5 className="mb-0">
                <button
                  className="btn btn-link small-text pl-5 text-left collapsed"
                  aria-expanded="false"
                >
                  <i
                    className={
                      cardType === "Visa"
                        ? "fa fa-cc-visa fa-2x"
                        : cardType === "Mastercard"
                        ? "fa fa-cc-mastercard fa-2x"
                        : cardType === "American Express"
                        ? "fa fa-cc-amex fa-2x"
                        : cardType === "Diners Club"
                        ? "fa fa-cc-diners-club fa-2x"
                        : cardType === "Discover"
                        ? "fa fa-cc-discover fa-2x"
                        : cardType === "JCB"
                        ? "fa fa-cc-jcb fa-2x"
                        : "fa fa-credit-card fa-2x"
                    }
                  ></i>{" "}
                  {cardNumber.length <= 12
                    ? "*".repeat(16 - cardNumber.length) + cardNumber
                    : cardNumber}{" "}
                  <span
                    style={{
                      display: "block",
                      fontSize: "11px",
                      color: "var(--iq-text-color)",
                      paddingLeft: "2.6rem",
                    }}
                  >
                    {"Expires on " + cardMonth + " " + cardYear}
                  </span>
                </button>
              </h5>
              <div className="row">
                <div className="col-lg-12">
                  <Link
                    to="#!"
                    onClick={displayCard}
                    style={{
                      float: "right",
                      marginRight: "8px",
                      fontSize: "1rem",
                    }}
                  >
                    {change ? "Close" : "Change"}
                  </Link>
                </div>
              </div>
            </div>
            <div
              id="collapseTwo"
              className={change ? "collapse show" : "collapse"}
            >
              <div className="card-body form-div ">
                <form onSubmit={saveDefaultCard}>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        {" "}
                        <label htmlFor="username">
                          <h6>
                            Card Owner{" "}
                            <span className={nameValid ? " " : "color_red"}>
                              {nameValid ? "" : "(Invalid Name)"}
                            </span>
                          </h6>
                        </label>{" "}
                        <input
                          type="text"
                          name="username"
                          placeholder="Card Owner Name"
                          defaultValue={owner}
                          onChange={(e) => {
                            setOwner(e.target.value);
                          }}
                          required
                          className={
                            nameValid
                              ? "form-control "
                              : "form-control error_border"
                          }
                          onBlur={validateName}
                        />{" "}
                      </div>
                      <div className="form-group">
                        {" "}
                        <label htmlFor="cardNumber">
                          <h6>
                            Card number{" "}
                            <span className={cardValid ? " " : "color_red"}>
                              {cardValid ? "" : "(Invalid Card Number)"}
                            </span>
                          </h6>
                        </label>
                        <div className="input-group">
                          {" "}
                          <input
                            type="text"
                            name="cardNumber"
                            placeholder="Valid card number"
                            className={
                              cardValid
                                ? "form-control "
                                : "form-control error_border"
                            }
                            defaultValue={cardNumber}
                            onChange={(e) => {
                              setCardNumber(e.target.value);
                            }}
                            maxLength={16}
                            onBlur={validateCard}
                            required
                          />
                          <div className="input-group-append">
                            {" "}
                            <span className="input-group-text text-muted">
                              {" "}
                              <i className="fa fa-cc-visa mx-1" />{" "}
                              <i className="fa fa-cc-mastercard mx-1" />{" "}
                              <i className="fa fa-cc-amex mx-1" />{" "}
                            </span>{" "}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-8">
                      <div className="form-group">
                        {" "}
                        <label>
                          <span className="hidden-xs">
                            <h6>
                              Expiration Date{" "}
                              <span className={monthValid ? " " : "color_red"}>
                                {monthValid ? "" : "(Invalid Expiry Date)"}
                              </span>
                            </h6>
                          </span>
                        </label>
                        <div className="input-group">
                          {" "}
                          <input
                            type="number"
                            placeholder="MM"
                            name="expmonth"
                            className={
                              monthValid
                                ? "form-control "
                                : "form-control error_border"
                            }
                            defaultValue={cardMonth}
                            required
                            onChange={(e) => {
                              setCardMonth(e.target.value);
                            }}
                            maxLength={2}
                            onBlur={validateMonth}
                          />{" "}
                          <input
                            type="number"
                            placeholder="YY"
                            name="expyear"
                            className={
                              monthValid
                                ? "form-control "
                                : "form-control error_border"
                            }
                            required
                            onChange={(e) => {
                              setCardYear(e.target.value);
                            }}
                            defaultValue={cardYear}
                            maxLength={4}
                            onBlur={validateMonth}
                          />{" "}
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group mb-4">
                        {" "}
                        <label
                          data-toggle="tooltip"
                          title="Three digit CV code on the back of your card"
                        >
                          <h6>
                            CVV <i className="fa fa-question-circle d-inline" />
                            <span className={cvvValid ? " " : "color_red"}>
                              {cvvValid ? "" : "Bad CVV"}
                            </span>
                          </h6>
                        </label>{" "}
                        <input
                          type="text"
                          required
                          className={
                            cvvValid
                              ? "form-control "
                              : "form-control error_border"
                          }
                          onChange={(e) => {
                            setcvv(e.target.value);
                          }}
                          maxLength={4}
                          defaultValue={cvv}
                          onBlur={(e) => {
                            validateCVV();
                          }}
                        />{" "}
                      </div>
                    </div>
                  </div>

                  <div className="form-group button-block text-center">
                    <button
                      type="submit"
                      className="subscribe btn btn-primary btn-block shadow-sm"
                    >
                      Save Card
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default CardModal;
